import React, { JSX } from 'react';
import { PATHS } from 'src/common/constants';
import Anchor from 'src/components/Anchor';
import Auth from 'src/layouts/Auth/Auth';
import Input from 'src/components/Input';
import LoadingButton from 'src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton';
import { Images } from 'src/Tenants';
import { useForgotPasswordOrchestrator } from './CustomHooks/useForgotPasswordOrchestrator';

const ForgotPassword = (): JSX.Element => {
  const { email, canSubmit, isSubmitting, updateEmail, submit } =
    useForgotPasswordOrchestrator();

  const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    submit();
  };

  return (
    <Auth
      title="Forgot Password"
      backgroundImage={Images.signInImage}
      content={
        <div className="sign-in">
          <form onSubmit={onSubmit}>
            <div className="sign-in-header">
              <div className="sign-in-headline">Forgot password</div>
            </div>

            <Input
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                updateEmail(e.target.value)
              }
              label="Email Address"
              required
              block
            />

            <div className="sign-in-button">
              <LoadingButton
                actionText="Forgot Password"
                isSubmitting={isSubmitting}
                disabled={!canSubmit}
                submit
                block
                size={null}
              />
            </div>

            <div className="sign-in-footer">
              Remember your password?{' '}
              <Anchor path={PATHS.AUTH_SIGN_IN} label="Sign In" />
            </div>
          </form>
        </div>
      }
    />
  );
};

export default ForgotPassword;
